import { useQuery } from '@tanstack/react-query';
import type { CursorPage, Report } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useReports(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['reports', { projectId, limit }],
    queryFn: () => apiGet<CursorPage<Report>>(`/v1/reports?${params.toString()}`),
  });
}
